<template>
  <b-sidebar
    v-if="!isSplitMode"
    id="cortex-chat-drawer"
    :visible="isOpen"
    right
    shadow
    backdrop
    no-header
    bg-variant="dark"
    body-class="p-0 overflow-hidden"
    :width="effectiveDrawerWidth + 'px'"
    @hidden="onHidden"
  >
    <div class="cd-drawer-wrapper" :class="{ 'cd-drawer-wrapper--resizing': isResizing }">
      <div class="cd-resize-handle" @mousedown.stop="startResize"></div>
      <chat-panel />
    </div>
  </b-sidebar>
</template>

<script>
import ChatPanel from './ChatPanel'

var DEFAULT_DRAWER_WIDTH = 1040
var MIN_DRAWER_WIDTH = 720
var MAX_DRAWER_VIEWPORT_RATIO = 0.95

function clampDrawerWidth (width, viewportWidth) {
  var maxWidth = Math.floor(viewportWidth * MAX_DRAWER_VIEWPORT_RATIO)
  if (maxWidth < MIN_DRAWER_WIDTH) {
    return maxWidth
  }
  return Math.max(MIN_DRAWER_WIDTH, Math.min(maxWidth, width))
}

export default {
  name: 'ChatDrawer',
  components: { ChatPanel },
  data: function () {
    return {
      drawerWidth: DEFAULT_DRAWER_WIDTH,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : Math.ceil(DEFAULT_DRAWER_WIDTH / MAX_DRAWER_VIEWPORT_RATIO),
      isResizing: false,
      resizeStartX: 0,
      resizeStartWidth: 0
    }
  },
  computed: {
    isOpen: function () {
      return this.$store.state.cortex.isOpen
    },
    isSplitMode: function () {
      return this.$store.state.cortex.isSplitMode
    },
    effectiveDrawerWidth: function () {
      return clampDrawerWidth(this.drawerWidth, this.viewportWidth)
    }
  },
  watch: {
    isOpen: function (val) {
      if (val) {
        this.$store.dispatch('cortex/openChat')
        this.$store.dispatch('cortex/loadAgents')
      }
    }
  },
  methods: {
    onHidden: function () {
      this.$store.commit('cortex/SET_OPEN', false)
    },
    startResize: function (e) {
      this.isResizing = true
      this.updateViewportWidth()
      this.resizeStartX = e.clientX
      this.resizeStartWidth = this.drawerWidth
      document.addEventListener('mousemove', this.onResize)
      document.addEventListener('mouseup', this.stopResize)
    },
    onResize: function (e) {
      if (!this.isResizing) return
      var delta = this.resizeStartX - e.clientX
      var newWidth = this.resizeStartWidth + delta
      this.drawerWidth = clampDrawerWidth(newWidth, this.viewportWidth)
    },
    stopResize: function () {
      this.isResizing = false
      document.removeEventListener('mousemove', this.onResize)
      document.removeEventListener('mouseup', this.stopResize)
    },
    updateViewportWidth: function () {
      if (typeof window !== 'undefined') {
        this.viewportWidth = window.innerWidth
      }
    }
  },
  mounted: function () {
    this.updateViewportWidth()
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.updateViewportWidth)
    }
    // Keep the overlay drawer aligned with the viewport edge.
    this.$nextTick(function () {
      var el = document.getElementById('cortex-chat-drawer')
      if (el) {
        el.style.setProperty('height', '100vh', 'important')
        el.style.setProperty('max-height', '100vh', 'important')
        el.style.setProperty('top', '0', 'important')
        el.style.setProperty('bottom', '0', 'important')
        el.style.setProperty('border-radius', '0', 'important')
        el.style.setProperty('box-shadow', '-4px 4px 32px rgba(0,0,0,0.5)', 'important')
      }
      var body = el && el.querySelector('.b-sidebar-body')
      if (body) {
        body.style.setProperty('height', '100%', 'important')
        body.style.setProperty('border-radius', '0', 'important')
      }
    })
  },
  beforeDestroy: function () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateViewportWidth)
    }
    document.removeEventListener('mousemove', this.onResize)
    document.removeEventListener('mouseup', this.stopResize)
  }
}
</script>

<style lang="scss">
/* ── Keep the overlay drawer flush with the viewport ── */
#cortex-chat-drawer.b-sidebar {
  height: 100vh !important;
  max-height: 100vh;
  top: 0 !important;
  bottom: 0;
  border-radius: 0;
  background: #1a1d27 !important;
  box-shadow: -4px 4px 32px rgba(0, 0, 0, 0.5);
}

#cortex-chat-drawer .b-sidebar-body {
  padding: 0 !important;
  overflow: hidden !important;
  height: 100% !important;
  border-radius: 0;
}
</style>

<style scoped lang="scss">
.cd-drawer-wrapper {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;

  &--resizing {
    user-select: none;
  }
}

.cd-resize-handle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  cursor: ew-resize;
  z-index: 10;
  background: transparent;
  transition: background 0.15s;

  &:hover {
    background: rgba(108, 128, 255, 0.2);
  }
}
</style>
